import { useEffect } from 'react';

export function useScrollToHash() {
  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }, []);
}